var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2222 7.66666H4.77774C4.16409 7.66666 3.66663 8.16412 3.66663 8.77777V19.8889C3.66663 20.5025 4.16409 21 4.77774 21H19.2222C19.8358 21 20.3333 20.5025 20.3333 19.8889V8.77777C20.3333 8.16412 19.8358 7.66666 19.2222 7.66666Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11133 11.75C8.31066 11.7501 8.47266 11.912 8.47266 12.1113C8.47254 12.3106 8.31059 12.4725 8.11133 12.4727C7.91196 12.4727 7.75012 12.3107 7.75 12.1113C7.75 11.9119 7.91189 11.75 8.11133 11.75Z",
    fill: "#8C8C8C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8892 11.75C16.0885 11.7501 16.2505 11.912 16.2505 12.1113C16.2504 12.3106 16.0884 12.4725 15.8892 12.4727C15.6898 12.4727 15.5279 12.3107 15.5278 12.1113C15.5278 11.9119 15.6897 11.75 15.8892 11.75Z",
    fill: "#8C8C8C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4723 16.1945V16.9171H10.528V16.1945H13.4723Z",
    fill: "#333333",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.22223V7.66667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.1111V16.5555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.1111V16.5555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.22222C12.6137 3.22222 13.1111 2.72476 13.1111 2.11111C13.1111 1.49746 12.6137 1 12 1C11.3864 1 10.8889 1.49746 10.8889 2.11111C10.8889 2.72476 11.3864 3.22222 12 3.22222Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.a5a14ab4a6b9794a323ddb282d046c16.svg";
export { ForwardRef as ReactComponent };